import { Star } from '@phosphor-icons/react';

/**
 * Mini pill con star + calificación sobre un gradiente morado que se
 * desvanece de izquierda a derecha. Diseño reutilizable.
 *
 * Usos:
 *   - Standalone en sheets de producto (ProductDetailSheet) — `size="md"`
 *   - Anidado dentro del SVG "folder tab" de una card — `size="sm"`
 *
 * `inline-flex` sized to content; el consumer puede envolverlo o pasarle
 * `className` con `absolute top-X left-Y` para posicionarlo.
 */
export default function RatingChip({ rating = 4.5, size = 'sm', className = '' }) {
  const isSm = size === 'sm';
  // sm (default): folder tabs de las cards
  // md: uso standalone más visible (ProductDetailSheet)
  const starSize = isSm ? 13 : 14;
  const textCls = isSm ? 'text-[14px]' : 'text-sm';

  return (
    <div className={`inline-flex items-center py-0.5 pl-0.5 pr-0.5 gap-0.5 bg-linear-to-r from-brand-primary/14 to-brand-primary/0 rounded ${className}`}>
      <Star size={starSize} weight="fill" className="text-budgetmeals-accent" />
      <span className={`${textCls} font-semibold text-budgetmeals-rating-text leading-none`}>
        {rating.toFixed(1)}
      </span>
    </div>
  );
}
